import {
  Component,
  ComponentInterface,
  h,
  Prop,
} from '@stencil/core';

import { format } from 'date-fns/format';

import { removeTimezoneFromIsoTimeString } from '../../utils/date-helper';

@Component({
  shadow: true,
  styleUrl: 'paf-result-time.scss',
  tag: 'paf-result-time',
})

export class PafResultTime implements ComponentInterface {

  /**
   * Departure time defined as ISO 8601 timestamp (e.g. 2022-12-11T14:11:00),
   * will be transformed and rendered in HH:MM format (14:11).
  */
  @Prop() public time!: string;

  /**
   * Delay defined in minutes
   */
  @Prop() public delay?: string;

  public render(): HTMLDivElement {
    const showDelay = this.delay && this.delay.length > 0;
    const timeWithoutTimezone: Date = removeTimezoneFromIsoTimeString(this.time);

    return (
      <div class='paf-result-time'>
        <time class='paf-result-time__time' dateTime={this.time}>
          {format(timeWithoutTimezone, 'HH:mm')}
        </time>
        {showDelay
          ? <p class='paf-result-time__delay'>
            {this.delay}
          </p>
          : undefined
        }
      </div>
    );
  }
}
